import { useLocation, useNavigate } from "react-router-dom";
import { theme } from "../theme";
import { useApp } from "../AppContext";
import { OKRAJ } from "./Sidebar";

export const TOPBAR_HEIGHT = 64;

export default function TopBar({ compact, onOpenMenu, paddingX = 28 }) {
  const { searchQuery, setSearchQuery, loadProducts, setShowAddModal } = useApp();
  const location = useLocation();
  const navigate = useNavigate();

  const onProducts = location.pathname === "/produkty";
  const onDashboard = location.pathname === "/";

  const ghostBtn = {
    background: theme.bg, border: `1px solid ${theme.line}`, borderRadius: theme.rBtn,
    padding: "9px 14px", color: theme.inkSoft, fontSize: 13.5, fontWeight: 600,
    display: "flex", alignItems: "center", gap: 7, cursor: "pointer", fontFamily: "inherit",
    whiteSpace: "nowrap",
  };

  // hledání je o produktech — když uživatel píše jinde, přepni na Produkty
  const onSearch = (v) => {
    setSearchQuery(v);
    if (v && !onProducts) navigate("/produkty");
  };

  return (
    <header style={{
      minHeight: TOPBAR_HEIGHT, flexShrink: 0,
      // Sedi na pozadi stranky jako v navrhu, ne v bilem pruhu. Pozadi je
      // potreba kvuli sticky — obsah pod nim jinak prosvita pri rolovani.
      background: theme.bgSoft,
      display: "flex", alignItems: "center", gap: 12,
      padding: `${OKRAJ}px ${paddingX}px ${OKRAJ - 4}px`,
      position: "sticky", top: 0, zIndex: 40,
    }}>
      {compact && (
        <button onClick={onOpenMenu} aria-label="Otevřít menu" style={{ ...ghostBtn, padding: "9px 10px" }}>
          <svg width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round"><path d="M3 6h18M3 12h18M3 18h18"/></svg>
        </button>
      )}

      {/* vyhledávání */}
      <div style={{ position: "relative", flex: 1, maxWidth: 360, minWidth: 0 }}>
        <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke={theme.mut} strokeWidth="2" strokeLinecap="round" style={{ position: "absolute", left: 12, top: "50%", transform: "translateY(-50%)", pointerEvents: "none" }}><circle cx="11" cy="11" r="7"/><path d="m21 21-4.3-4.3"/></svg>
        <input
          value={searchQuery}
          onChange={e => onSearch(e.target.value)}
          placeholder="Hledat produkt…"
          style={{
            width: "100%", boxSizing: "border-box",
            border: `1px solid ${theme.line}`, borderRadius: 10,
            padding: "9px 32px 9px 34px", fontSize: 13.5,
            fontFamily: "inherit", color: theme.ink, background: theme.bgSoft,
            outline: "none",
          }}
          onFocus={e => e.target.style.borderColor = theme.blueLine}
          onBlur={e => e.target.style.borderColor = theme.line}
        />
        {searchQuery && (
          <button onClick={() => setSearchQuery("")} aria-label="Zrušit hledání" style={{
            position: "absolute", right: 8, top: "50%", transform: "translateY(-50%)",
            background: "none", border: "none", color: theme.mut, cursor: "pointer",
            fontSize: 14, lineHeight: 1, padding: 4, fontFamily: "inherit",
          }}>✕</button>
        )}
      </div>

      <div style={{ marginLeft: "auto", display: "flex", alignItems: "center", gap: 9 }}>
        {(onDashboard || onProducts) && (
          <button onClick={loadProducts} style={ghostBtn}>
            <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.5" strokeLinecap="round">
              <path d="M1 4v6h6M23 20v-6h-6"/><path d="M20.49 9A9 9 0 0 0 5.64 5.64L1 10m22 4l-4.64 4.36A9 9 0 0 1 3.51 15"/>
            </svg>
            {!compact && "Obnovit"}
          </button>
        )}
        {onProducts && (
          <button id="tour-add" onClick={() => setShowAddModal(true)} style={{
            background: `linear-gradient(135deg, ${theme.blue}, ${theme.blueDark})`, border: "none",
            borderRadius: theme.rBtn, padding: "10px 16px", color: "#fff",
            fontSize: 13.5, fontWeight: 700, cursor: "pointer", fontFamily: "inherit",
            display: "flex", alignItems: "center", gap: 7, whiteSpace: "nowrap",
            boxShadow: "0 4px 16px #126DFB30",
          }}>
            <svg width="15" height="15" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2.6" strokeLinecap="round"><path d="M12 5v14M5 12h14"/></svg>
            {compact ? "Přidat" : "Přidat produkt"}
          </button>
        )}
      </div>
    </header>
  );
}
